import React from "react";
import { useParams } from "next/navigation";
import { DayPicker } from "react-day-picker";
import { es } from "react-day-picker/locale";
import { DesktopCalendarProps } from "./types";
import { modifiersClassNames } from "../../utils/modifiers";
import "react-day-picker/style.css";

const DesktopCalendar = ({
  month,
  setMonth,
  selectedDate,
  minDate,
  maxDate,
  handleSelect,
}: DesktopCalendarProps) => {
  const { lang } = useParams();
  return (
    <div className="DateInput__children">
      <DayPicker
        data-testid="date-picker-modal"
        locale={lang === "es" ? es : undefined}
        captionLayout="dropdown"
        month={month}
        onMonthChange={setMonth}
        startMonth={minDate}
        endMonth={maxDate}
        mode="single"
        required
        selected={selectedDate}
        onSelect={handleSelect}
        className="DatePicker"
        modifiersClassNames={modifiersClassNames}
        disabled={{ before: minDate, after: maxDate }}
      />
    </div>
  );
};

export default DesktopCalendar;
